// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"f41e0f4c","113":"ed3d8415","130":"d51045c5","160":"6bf6d14d","248":"668f58ef","446":"ba1f212c","560":"680f0211","671":"fd511af0","696":"b6ef370d","736":"4561645e","785":"74f8d236","853":"bcea3811","883":"438bda31","916":"2ff6dffb","920":"3b23bbae"}[chunkId] + ".chunk.js";
};